import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedGroupForm = (props) => {
    const initialFormData = {
        medgroup: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const formRef = useRef(null);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);

    useEffect(() => {
        const val = props.medgrpvalue;
        if (val && (val.group_id || val.med_group_id || val.id)) {
            const { group, group_name, is_active, group_id, med_group_id, id } = val;
            setFormData({
                medgroup: group || group_name || "",
                isactive: is_active == 1 || is_active === '1' || is_active === true,
                id: group_id || med_group_id || id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.medgrpvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");

        let pelmedsMedGroupUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/drugs/add-drug-group` : `${process.env.REACT_APP_SERVER_URL}/drugs/update-drug-group`;

        let pelmedsMedGroupData = isAddMode ? 
            { "name": formData.medgroup, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "name": formData.medgroup, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsMedGroupUrl, pelmedsMedGroupData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success(isAddMode ? "MedGroup added successfully" : "MedGroup updated successfully");
        }
        else {
            toast.info("Error while adding/updating MedGroup");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Med Group</Form.Label>
                        <Form.Control
                            placeholder='Med Group'
                            value={formData.medgroup}
                            name="medgroup"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            size="sm"
                            disabled={!formData.medgroup}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};

MedGroupForm.propTypes = {
    medgrpvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default MedGroupForm;
